<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{'RelativeUsers' | lang}}</div>
    </header>
    <div>
      <relativeUsers />
    </div>
    <!-- <footer>
      <button @click="logout">{{ 'logout' | lang }}</button>
    </footer> -->
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import relativeUsers from '@/components/RelativeUsers.vue'

export default {
  name: 'RelativeUsersPage',
  mixins: [ page ],
  components: { relativeUsers },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  beforeDestroy () {},
  mounted () {},
  watch: {}
}
</script>

<style lang="scss">

</style>
